import axios from '../../axios'

// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/platlog/listByPage',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/modules/platlog/platlog.js